import { Grid } from "@mui/material";
import { PeriodoAcademicoDTO, VoidPeriodoAcademicoDTO } from "../../interfaces/SAAC/PeriodoAcademicoDTO";
import { useContext, useEffect, useState } from "react";
import AcademicoService from "../../services/AcademicoService";
import AlertService from "../../services/AlertService";
import AyudantiaService from "../../services/AyudantiaService";
import ProyectoService from "../../services/ProyectoService";
import UsuarioService from "../../services/UsuarioService";
import { CasUserContext, useCasUserContext } from "../../services/casUserContext";


const alertaService = new AlertService();
const usuarioService = new UsuarioService();
const ayudantiaService = new AyudantiaService();
const proyectoService = new ProyectoService();
const academicoService = new AcademicoService();
export const SolicitudesAyudantia: React.FC<{}> = () =>{
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const [periodoActivo, setPeriodoActivo] = useState<PeriodoAcademicoDTO>(VoidPeriodoAcademicoDTO());
    const token = casUserContext.token;
    const GetPeriodo = async () => {
        await academicoService.GetPeriodoAcademicoEnEjecucion(token)
          .then((data) => {
            setPeriodoActivo(data.data)
          })
          .catch((error) => console.error(error));
      };
      useEffect(() => {
        GetPeriodo();
      },[token] );
    return (  
        <Grid container spacing={2} sx={{mt:8}}>
            <Grid item xs={12}>
                Componente Vacio para usar para crear nuevos
            </Grid>
        </Grid>             
      );
  }